// Mobile Nav
import { debounce } from 'lodash';

const isInViewport = elem => {
  const bounding = elem.getBoundingClientRect();
  return (
    bounding.top >= 0 &&
    bounding.left >= 0 &&
    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

const rightAlignWithViewport = elem => {
  const secondLevelLi = elem;
  const bounding = secondLevelLi.getBoundingClientRect();
  if (bounding.left + bounding.width >= document.documentElement.clientWidth) {
    const moveDistance = bounding.left + bounding.width - document.documentElement.clientWidth;
    secondLevelLi.style.transform = `translateX(0)`;
    secondLevelLi.style.transform = `translateX(-${moveDistance}px)`;
  }
};

const alignWithViewport = elem => {
  const bounding = elem.getBoundingClientRect();
  const thirdLevelLi = elem;
  if (bounding.left + bounding.width >= document.documentElement.clientWidth) {
    let moveDistance = -bounding.width;
    const parentLi = thirdLevelLi.closest('.menu-item-has-children');
    const parentWidth = parentLi.getBoundingClientRect().width;
    moveDistance -= parentWidth;
    thirdLevelLi.style.transform = `translateX(0)`;
    thirdLevelLi.style.transform = `translateX(${moveDistance}px)`;
  }
};

document.body.addEventListener('mouseover', event => {
  if (
    !event.target.matches('.primaryNav-mainMenu li > a') &&
    !event.target.matches('.primaryNav-mainMenu li > a *') &&
    !event.target.matches('.primaryNav-mainMenu li')
  ) {
    return;
  }

  const secondLevelNav = document.querySelectorAll(
    '.primaryNav-mainMenu > li > .primaryNav-subMenu',
  );
  const thirdLevelNav = document.querySelectorAll('.primaryNav-subMenu .primaryNav-subMenu');

  for (let i = 0; i < secondLevelNav.length; i += 1) {
    if (!isInViewport(secondLevelNav[i])) {
      rightAlignWithViewport(secondLevelNav[i]);
    }
  }

  for (let i = 0; i < thirdLevelNav.length; i += 1) {
    if (!isInViewport(thirdLevelNav[i])) {
      alignWithViewport(thirdLevelNav[i]);
    }
  }
});

const calculateOffscreenElements = () => {
  const thirdLevelNav = document.querySelectorAll('.primaryNav-subMenu .primaryNav-subMenu');

  for (let i = 0; i < thirdLevelNav.length; i += 1) {
    if (!isInViewport(thirdLevelNav[i])) {
      alignWithViewport(thirdLevelNav[i]);
    } else {
      thirdLevelNav[i].style.transform = `translateX(0)`;
    }
  }
};

window.addEventListener('resize', debounce(calculateOffscreenElements, 300));

const navArrows = document.querySelectorAll('.primaryNav .drop-icon');
navArrows.forEach(el => {
  el.addEventListener('click', () => {
    el.classList.toggle('drop-icon-up');
  });
});

/**
 * Mobile menu toggle
 */
const toggle = document.getElementById('toggle-menu');
// eslint-disable-next-line no-unused-expressions
toggle?.addEventListener('click', () => {
  const isActive = toggle.classList.contains('active');

  if (isActive) {
    toggle.classList.add('closed');
  } else {
    toggle.classList.remove('closed');
  }

  toggle.classList.toggle('active');
});
